import App from '../main';
import BaseGamePlay from './basegameplay';

export default class NormalMode extends BaseGamePlay {
    protected platformAmount: number = 9;
    protected platformStep: number = 0.75 * 350;

    protected boundry: any;

    protected easeFunction: any;
    protected platformScale: number;
    protected platformSpeed: number;

    protected minPlatformSpeed: number = 1.7;
    protected maxPlatformSpeed: number = 1.7;
    protected minPlatformSize: number = 0.8;
    protected maxPlatformSize: number = 0.9;

    protected laserSpeed: number = 250;
    protected laserHold: number = 2000;
    protected laserDelay: number = 2500;

    protected bulletSpeed: number = 1500;
    protected bulletDelay: number = 1000;

    constructor() {
        super('NormalMode', App.GAME_DROP_SPEED);
    }

    create() {
        super.create();
        this.isRushMode = false;
        this.setCollectibleProbability(false);
        this.setSpecialPlatformProbability();
        this.setPlatformDesignRandoms();

        this.boundry = this.physics.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT, 'Platform', 'Platform_0').setScale(0.75 * 2, 1).setVisible(false);
        this.boundry.setImmovable(true).body.allowGravity = false;

        this.setAnims();
        if (this.events.listenerCount('wake') <= 0) {
            this.events.on('wake',  () => {
                this.cameras.main.fadeIn(250, 255, 255, 255);
                this.inputEnabled = false;
                this.time.addEvent({
                    delay: 500,
                    callback: () => this.inputEnabled = true,
                    callbackScope: this
                });
                this.score = this.registry.get('score');
                this.highScore = this.registry.get('highScore');
                this.stars = this.registry.get('stars');
                this.isRushMode = false;
            }, this);
        }

        this.physics.add.overlap(this.player, this.boundry, () => this.emitter.emit('fall'), null, this);
        this.physics.add.overlap(this.player, this.obstacles, this.hitObstacle, null, this);

        App.SDK.canShowInterstitialAd = true;
    }

    update() {
        super.update();
        this.boundry.y = this.cameras.main.midPoint.y + App.MAX_HEIGHT_HALF + (this.boundry.displayHeight / 2);
        this.platforms.children.iterate((platform: any) => {
            if (platform.y < this.player.y) {
                this.emitter.emit('gameOver');
            }
        }, this)
    }

    addScore(scoreToAdd, isStar) {
        if (!isStar) {
            this.gameScore += scoreToAdd;
        }
        super.addScore(scoreToAdd, isStar);
    }

    setAnims() {
        super.setAnims();
        this.anims.create({
            key: 'bulletAnim',
            frames: this.anims.generateFrameNames('bullet'),
            frameRate: 24,
            repeat: -1
        });
        this.anims.create({
            key: 'explosionAnim',
            frames: this.anims.generateFrameNames('explosion'),
            frameRate: 24,
            repeat: 0,
            hideOnComplete: true
        });
        this.anims.create({
            key: 'smokeAnim',
            frames: this.anims.generateFrameNames('smoke'),
            frameRate: 24,
            repeat: 0,
            hideOnComplete: true
        });
        this.anims.create({
            key: 'warningAnim',
            frames: this.anims.generateFrameNames('warning'),
            frameRate: 24,
            repeat: -1,
            hideOnComplete: true
        });
    }

    hitObstacle(player, obstacle) {
        this.sound.play('Explosion');
        if (obstacle.type == 'bullet') {
            obstacle.setVisible(false);
            this.add.sprite(player.x, player.y, 'explosion', 'explosion_0').play('explosionAnim');
        }
        else if (obstacle.type == 'laser') {
            this.add.sprite(player.x, player.y, 'smoke', 'smoke_0').play('smokeAnim');
        }
        player.disableBody(true, true);
        if (!this.gameOver) {
            this.emitter.emit('gameOver');
        }
        this.cameras.main.shake(300, 0.01);
    }

    removePlatform() {
        var toRemove: any = this.getCurrentPlatform();
        if (toRemove && !this.gameOver) {
            if (toRemove.isFirstPlatform && this.scene.isActive('Tutorial')) {
                this.scene.stop('Tutorial');
                App.TUTORIAL_SHOWN = true;
            }
            if (this.activePowerUp == 'ice') {
                this.activePowerUp = '';
                this.registry.set('powerup', this.activePowerUp);
            }
            toRemove.startTween.stop();
            toRemove.tween.stop();
            if (toRemove.timer) {
                toRemove.timer.remove();
            }
            this.setPlatformBehaviour(toRemove);
            if (this.activePowerUp == 'spring') {
                toRemove.setScale(toRemove.scaleX * 1.25, toRemove.scaleY);
                toRemove.fill.setScale(toRemove.scaleX, toRemove.scaleY);
                toRemove.top.setScale(toRemove.scaleX, toRemove.scaleY);
                toRemove.pattern.setScale(toRemove.scaleX, toRemove.scaleY);

                toRemove.spikeOutline.setScale(toRemove.scaleX * 1.25, toRemove.scaleY);
                toRemove.spikeFill.setScale(toRemove.scaleX, toRemove.scaleY);
                toRemove.spikeTop.setScale(toRemove.scaleX, toRemove.scaleY);
                toRemove.spikePattern.setScale(toRemove.scaleX, toRemove.scaleY);
            }
        }
        super.removePlatform();

    }

    initPlatforms() {
        super.initPlatforms();
        this.platforms.children.iterate( (platform: any) => {
            if (platform == this.platforms.getChildren()[0]) {
                platform.isFirstPlatform = true;
                platform.collectible.disableBody(true, true);
            }
            else {
                platform.isFirstPlatform = false;
                platform.setVisible(false).design.setVisible(false);
                platform.spikeDesign.setVisible(true);
            }
            platform.ease = 'InOutQuad';
            this.setPlatformBehaviour(platform);
        }, this);
    }

    setPlatformBehaviour(platform) {
        if (this.numberOfPlatforms <= 10) {
            platform.ease = 'InOutQuad';
            this.setPlatformProperties(platform);
        }
        else {
            if (platform == this.platforms.getChildren()[this.obstacle]) {
                platform.hasObstacle = true;
            }
            else {
                platform.hasObstacle = false;
            }
            if (platform == this.platforms.getChildren()[this.special1]) {
                this.shuffleSpecialPlatform(platform);
            }
            else if (platform == this.platforms.getChildren()[this.special2]) {
                this.shuffleSpecialPlatform(platform);
            }
            else {
                platform.ease = 'InOutQuad';
                this.setPlatformProperties(platform);
            }
        }
    }

    shuffleSpecialPlatform(platform) {
        if (platform.ease == 'InOutQuad' && this.numberOfPlatforms > 10) {
            var specialRandom = 0;
            var level = this.gameScore + 10;
            if (level <= 100) {
                specialRandom = (Phaser.Math.CeilTo(level, 1, 10) / 10) - 1;
            }
            else {
                specialRandom = Phaser.Math.FloatBetween(0, 9);
            }
            if (specialRandom <= 1) {
                platform.ease = 'CentreStopLeftRight';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 2) {
                platform.ease = 'CentreStopLeft';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 3) {
                platform.ease = 'RightNormalLeftFast';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 4) {
                platform.ease = 'NormalToSpeed';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 5) {
                platform.ease = 'SpeedToSlow';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 6) {
                platform.ease = 'SlowToSpeed';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 7) {
                platform.ease = 'SlowEnd';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 8) {
                platform.ease = 'ZigZag';
                this.setPlatformProperties(platform);
            }
            else if (specialRandom <= 9) {
                platform.ease = 'SuddenFast';
                this.setPlatformProperties(platform);
            }
        }
        else {
            platform.ease = 'InOutQuad';
            this.setPlatformProperties(platform);
        }
    }

    setPlatformProperties(platform) {
        this.setPlatformSizeAndSpeed();
        switch (platform.ease) {
            case 'InOutQuad':
                this.easeFunction = Phaser.Tweens.Builders.GetEaseFunction('Quad.easeInOut');
                break;
            case 'CentreStopLeftRight':
                this.easeFunction = this.centreStopLeftRight;
                break;
            case 'CentreStopLeft':
                this.easeFunction = Phaser.Tweens.Builders.GetEaseFunction('Quad.easeOut');
                break;
            case 'RightNormalLeftFast':
                this.easeFunction = this.rightNormalLeftFast;
                break;
            case 'NormalToSpeed':
                this.easeFunction = this.normalToSpeed;
                break;
            case 'SlowToSpeed':
                this.easeFunction = this.slowToSpeed;
                break;
            case 'SpeedToSlow':
                this.easeFunction = this.speedToSlow;
                break;
            case 'SlowEnd':
                this.easeFunction = this.slowEnd;
                break;
            default:
                break;
        }
        this.setPlatform(platform, this.platformScale);
    }

    setPlatformSizeAndSpeed() {
        if (this.numberOfPlatforms <= 10) {
            this.minPlatformSpeed = 1.7;
            this.maxPlatformSpeed = 1.7;
            this.minPlatformSize = 0.8;
            this.maxPlatformSize = 0.9;
        }
        else if (this.numberOfPlatforms <= 20) {
            this.minPlatformSpeed = 1.6;
            this.maxPlatformSpeed = 1.7;
            this.minPlatformSize = 0.7;
            this.maxPlatformSize = 0.8;
        }
        else if (this.numberOfPlatforms <= 30) {
            this.minPlatformSpeed = 1.5;
            this.maxPlatformSpeed = 1.6;
            this.minPlatformSize = 0.6;
            this.maxPlatformSize = 0.7;
        }
        else if (this.numberOfPlatforms <= 40) {
            this.minPlatformSpeed = 1.4;
            this.maxPlatformSpeed = 1.5;
            this.minPlatformSize = 0.5;
            this.maxPlatformSize = 0.6;
        }
        else if (this.numberOfPlatforms <= 50) {
            this.minPlatformSpeed = 1.3;
            this.maxPlatformSpeed = 1.4;
            this.minPlatformSize = 0.4;
            this.maxPlatformSize = 0.5;
        }
        else if (this.numberOfPlatforms <= 60) {
            this.minPlatformSpeed = 1.15;
            this.maxPlatformSpeed = 1.3;
            this.minPlatformSize = 0.3;
            this.maxPlatformSize = 0.4;
        }
        else if (this.numberOfPlatforms <= 65) {
            this.minPlatformSpeed = 1.5;
            this.maxPlatformSpeed = 1.6;
            this.minPlatformSize = 0.2;
            this.maxPlatformSize = 0.3;
        }

        this.platformScale = 0.75 * Phaser.Math.FloatBetween(this.minPlatformSize, this.maxPlatformSize);
        this.platformSpeed = Phaser.Math.FloatBetween(this.minPlatformSpeed, this.maxPlatformSpeed);
    }

    setPlatform(platform, scale) {
        platform.speed = this.platformSpeed * 1000;
        platform.easeFunction = this.easeFunction;
        platform.setScale(scale, 0.75 * 0.5);
        platform.fill.setScale(platform.scaleX, platform.scaleY);
        platform.top.setScale(platform.scaleX, platform.scaleY);
        platform.pattern.setScale(platform.scaleX, platform.scaleY);
        platform.spikeOutline.setScale(platform.scaleX, platform.scaleY);
        platform.spikeFill.setScale(platform.scaleX, platform.scaleY);
        platform.spikeTop.setScale(platform.scaleX, platform.scaleY);
        platform.spikePattern.setScale(platform.scaleX, platform.scaleY);

        platform.mouth.setScale(0.75 * 0.5, 0.75 * 0.5);
        platform.rightEye.x = (platform.displayWidth / 2) - 0.75 * 50;
        platform.rightEye.y = 7.5;
        platform.leftEye.x = -platform.rightEye.x;
        platform.leftEye.y = 7.5;
        platform.collectible.x = platform.x;
        platform.collectible.y = platform.y - ((platform.displayHeight / 2) + 0.75 * 30);
        platform.collectible.glow.x = platform.collectible.x;
        platform.collectible.glow.y = platform.collectible.y;

        this.setPlatformMovement(platform);
        if (platform.hasObstacle) {
            this.setObstacle(platform);
        }
    }

    setObstacle(platform) {
        var rand = Phaser.Math.FloatBetween(0, 1);
        if (rand < 0.5) {
            this.setBulletObstacle(platform);
        }
        else {
            this.setLaserObstacle(platform);
        }
    }

    setBulletObstacle(platform) {
        platform.obstacle = this.obstacles.create(0, platform.y + this.platformStep, 'bullet', 'bullet_0').setFlipX(true);
        platform.obstacle.setImmovable(true).body.allowGravity = false;
        platform.obstacle.play('bulletAnim').type = 'bullet';
        platform.obstacle.warning = this.add.sprite(this.cameras.main.scrollX + 75, platform.obstacle.y, 'warning', 'warning_0').setScale(0.75 * 0.6).setVisible(false);
        var rand = Phaser.Math.FloatBetween(0, 1);
        var x1 = this.cameras.main.scrollX - 200;
        var x2 = App.MAX_WIDTH - this.cameras.main.scrollX + 200;
        if (rand < 1) {
            platform.obstacle.warning.x = App.MAX_WIDTH - this.cameras.main.scrollX - 75;
            platform.obstacle.setFlipX(false);
            x1 = App.MAX_WIDTH - this.cameras.main.scrollX + 200;
            x2 = this.cameras.main.scrollX - 200;
        }
        platform.obstacle.tween = this.tweens.add({
            targets: platform.obstacle,
            duration: this.bulletSpeed,
            x: { from: x1, to: x2 },
            loop: -1,
            loopDelay: this.bulletDelay,
            onStart: () => {
                platform.obstacle.setVisible(true);
                platform.obstacle.warning.setVisible(true).play('warningAnim');
            },
            onStartScope: this,
            onLoop: () => {
                platform.obstacle.setVisible(true);
                platform.obstacle.warning.setVisible(false);
                this.time.addEvent({
                    delay: this.bulletSpeed,
                    callback: () => {
                        platform.obstacle.setVisible(false);
                        platform.obstacle.warning.setVisible(true);
                    },
                    callbackScope: this
                });
            },
            onLoopScope: this
        });
    }

    setLaserObstacle(platform) {
        platform.obstacle = this.obstacles.create(0, platform.y + this.platformStep, 'laser').setScale(5, 0.75 * 1);
        platform.obstacle.setImmovable(true).body.allowGravity = false;
        platform.obstacle.type = 'laser';
        platform.obstacle.warning = this.add.sprite(this.cameras.main.scrollX + 75, platform.obstacle.y, 'warning', 'warning_0').setScale(0.75 * 0.6).setVisible(false);
        var rand = Phaser.Math.FloatBetween(0, 1);
        var x1 = this.cameras.main.scrollX - platform.obstacle.displayWidth / 2;
        if (rand < 0.5) {
            platform.obstacle.warning.x = App.MAX_WIDTH - this.cameras.main.scrollX - 75;
            x1 = App.MAX_WIDTH - this.cameras.main.scrollX + platform.obstacle.displayWidth / 2;
        }

        platform.obstacle.tween = this.tweens.add({
            targets: platform.obstacle,
            duration: this.laserSpeed,
            x: { from: x1, to: App.MAX_WIDTH_HALF },
            hold: this.laserHold,
            yoyo: true,
            loop: -1,
            loopDelay: this.laserDelay,
            onStart: () => {
                platform.obstacle.setVisible(true);
                platform.obstacle.warning.setVisible(true).play('warningAnim');
            },
            onStartScope: this,
            onLoop: () => {
                platform.obstacle.setVisible(true);
                platform.obstacle.warning.setVisible(false);
                if (this.cameras.main.worldView.contains(0, platform.obstacle.y)) {
                    this.sound.play('Laser');
                }
                this.time.addEvent({
                    delay: (this.laserSpeed * 2) + this.laserHold,
                    callback: () => {
                        platform.obstacle.setVisible(false);
                        platform.obstacle.warning.setVisible(true);
                    },
                    callbackScope: this
                });
            },
            onLoopScope: this
        });
    }

    setPlatformMovement(platform) {
        platform.rand = Phaser.Math.FloatBetween(0, 1);
        platform.destination1 = platform.displayWidth / 2;
        platform.destination2 = App.MAX_WIDTH - platform.displayWidth / 2;
        if (platform.rand < 0.5) {
            platform.destination1 = App.MAX_WIDTH - platform.displayWidth / 2;
            platform.destination2 = platform.displayWidth / 2;
        }

        var startYoyo = false;
        if (platform.ease == 'ZigZag') {
            startYoyo = true;
            platform.tween = this.tweens.timeline({
                targets: [platform, platform.features, platform.collectible, platform.collectible.glow, platform.design, platform.spikeDesign],
                paused: true,
                loop: -1,
                loopDelay: 500,
                tweens: [
                    {
                        delay: 500,
                        x: {
                            from: App.MAX_WIDTH_HALF,
                            to: { value: () => { return platform.destination1; } }
                        },
                        duration: platform.speed * 0.25 * 1.5,
                        ease: 'Quad.easeOut'
                    },
                    {
                        x: {
                            from: { value: () => { return platform.destination1; } },
                            to: { value: () => { return platform.destination2; } }
                        },
                        duration: platform.speed * 0.75,
                        yoyo: true,
                        ease: 'Quad.easeInOut'
                    },
                    {
                        x: {
                            from: { value: () => { return platform.destination1; } },
                            to: App.MAX_WIDTH_HALF
                        },
                        duration: platform.speed * 0.25 * 1.5,
                        ease: 'Quad.easeIn'
                    }
                ]
            });
        }
        else if (platform.ease == 'SuddenFast') {
            platform.tween = this.tweens.timeline({
                targets: [platform, platform.features, platform.collectible, platform.collectible.glow, platform.design, platform.spikeDesign],
                paused: true,
                loop: -1,
                tweens: [
                    {
                        x: {
                            from: { value: () => { return platform.destination1; } },
                            to: { value: () => { return platform.destination2; } }
                        },
                        duration: platform.speed * 0.35 * 1.5,
                        yoyo: true,
                        ease: 'Quad.easeIn'
                    },
                    {
                        x: {
                            from: { value: () => { return platform.destination1; } },
                            to: { value: () => { return platform.destination2; } }
                        },
                        duration: platform.speed * 0.65 * 1.5,
                        yoyo: true,
                        ease: 'Quad.easeInOut'
                    }
                ]
            });
        }
        else if (platform.ease == 'CentreStopLeft') {
            platform.tween = this.tweens.add({
                targets: [platform, platform.features, platform.collectible, platform.collectible.glow, platform.design, platform.spikeDesign],
                paused: true,
                x: {
                    from: { value: () => { return platform.destination1; } },
                    to: App.MAX_WIDTH_HALF
                },
                duration: platform.speed * 0.75,
                yoyo: true,
                repeat: -1,
                ease: platform.easeFunction
            });
        }
        else {
            platform.tween = this.tweens.add({
                targets: [platform, platform.features, platform.collectible, platform.collectible.glow, platform.design, platform.spikeDesign],
                paused: true,
                x: {
                    from: { value: () => { return platform.destination1; } },
                    to: { value: () => { return platform.destination2; } }
                },
                duration: platform.speed * 1.5,
                yoyo: true,
                repeat: -1,
                ease: platform.easeFunction
            });
        }

        platform.startTween = this.tweens.add({
            targets: [platform, platform.features, platform.collectible, platform.collectible.glow, platform.design, platform.spikeDesign],
            paused: false,
            x: platform.destination1,
            duration: platform.speed * 0.75,
            delay: 500,
            yoyo: startYoyo,
            ease: 'Quad.easeInOut',
            onComplete: () => {
                platform.tween.play();
            }
        });
    }

    centreStopLeftRight(t) {
        if (t <= 0.5) {
            return 2 * t * (1 - t);
        }
        t -= 0.5;
        return 2 * t * t + 0.5;
    }

    rightNormalLeftFast(t) {
        if (t <= 0.5) {
            return 2 * t * (1 - t);
        }
        t -= 0.5;
        return t + 0.5;
    }

    normalToSpeed(t) {
        if (t <= 0.25) {
            return 2 * t * (1 - (2 * t));
        }
        else if (t <= 0.5) {
            return 4 * (t -= 0.25) * t + 0.25;
        }
        else if (t <= 0.75) {
            return 2 * (t -= 0.5) * (1 - (2 * t)) + 0.5;
        }
        else {
            return 4 * (t -= 0.75) * t + 0.75;
        }

    }

    slowToSpeed(t) {
        if (t <= 0.9) {
            return t * (5 / 9);
        }
        t -= 0.9;
        return t * 5 + 0.5;
    }

    speedToSlow(t) {
        if (t <= 0.3) {
            return t * (8 / 3);
        }
        t -= 0.3;
        return t * (2 / 7) + 0.8;
    }

    slowEnd(t) {
        return t * t;
    }
}